// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hook-content {
  min-height: 100vh;
  width: 100%;
  background: var(--color-bg-root);
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  overflow-x: hidden;
}

.hook-main {
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  padding: 64px 24px 72px;
}

.hook-header {
  max-width: 680px;
  margin-bottom: 30px;
}

.hook-eyebrow {
  display: block;
  margin-bottom: 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
  color: var(--color-text-secondary);
}

.hook-title {
  margin: 0;
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: clamp(42px, 5.6vw, 68px);
  font-weight: 400;
  line-height: 1.02;
  color: var(--color-text-primary);
}

.hook-title-em {
  font-style: italic;
}

.hook-subtitle {
  max-width: 560px;
  margin: 16px 0 0;
  font-size: 15px;
  line-height: 1.6;
  color: var(--color-text-secondary);
}

.hook-config-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(280px, 0.75fr);
  gap: 18px;
  align-items: stretch;
}

.hook-panel {
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
}

.hook-panel--form {
  padding: 22px;
}

.hook-panel--aside {
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 14px;
}

.hook-section-header {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  margin-bottom: 18px;
}

.hook-section-header--compact {
  margin-bottom: 12px;
}

.hook-section-number {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 28px;
  line-height: 1;
  color: var(--color-text-primary);
  opacity: 0.16;
}

.hook-section-header h2,
.hook-panel--aside h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 650;
  color: var(--color-text-primary);
}

.hook-section-header p,
.hook-panel--aside p {
  margin: 5px 0 0;
  font-size: 13px;
  line-height: 1.55;
  color: var(--color-text-secondary);
}

.hook-file-input {
  display: none;
}

.hook-style-target {
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px solid var(--color-border-input);
}

.hook-character-target {
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px solid var(--color-border-input);
}

.hook-localization-target {
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px solid var(--color-border-input);
}

.hook-localization-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.hook-localization-grid label,
.hook-localization-notes {
  display: flex;
  flex-direction: column;
  gap: 7px;
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 650;
}

.hook-localization-grid input {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  padding: 0 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font: inherit;
  font-size: 13px;
  outline: 0;
}

.hook-localization-grid input:focus {
  border-color: var(--color-text-secondary);
}

.hook-localization-notes {
  margin-top: 12px;
}

.hook-localization-notes small {
  color: var(--color-text-secondary);
  font-size: 10px;
  font-weight: 500;
}

.hook-localization-model-note {
  margin: 12px 0 0;
  padding: 10px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font-size: 11px;
  line-height: 1.5;
}

.hook-style-textarea {
  width: 100%;
  min-height: 112px;
  display: block;
  box-sizing: border-box;
  padding: 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  line-height: 1.55;
  resize: vertical;
  outline: 0;
}

.hook-style-textarea:focus {
  border-color: var(--color-text-secondary);
}

.hook-style-reference-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
}

.hook-style-reference-bar span {
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 650;
}

.hook-style-upload-btn {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-secondary);
  font: inherit;
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}

.hook-style-upload-btn:disabled {
  opacity: 0.42;
  cursor: not-allowed;
}

.hook-style-reference-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(82px, 1fr));
  gap: 10px;
  margin-top: 12px;
}

.hook-style-reference-thumb {
  position: relative;
  aspect-ratio: 1;
  overflow: hidden;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
}

.hook-style-reference-thumb img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.hook-style-reference-thumb button {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: rgba(8, 9, 12, 0.78);
  color: var(--color-text-primary);
  cursor: pointer;
}

.hook-character-auth {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
}

.hook-character-auth p {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 13px;
  line-height: 1.45;
}

.hook-character-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.hook-character-tab {
  min-height: 34px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font: inherit;
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}

.hook-character-tab--active {
  background: var(--color-text-primary);
  border-color: var(--color-text-primary);
  color: var(--color-bg-root);
}

.hook-character-search {
  width: 100%;
  height: 38px;
  box-sizing: border-box;
  margin-top: 10px;
  padding: 0 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font: inherit;
  font-size: 13px;
  outline: 0;
}

.hook-character-search:focus {
  border-color: var(--color-text-secondary);
}

.hook-character-state {
  margin-top: 10px;
  padding: 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font-size: 12px;
  text-align: center;
}

.hook-character-grid {
  max-height: 360px;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 10px;
  margin-top: 12px;
  padding-right: 2px;
}

.hook-character-card {
  position: relative;
  min-height: 92px;
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  padding: 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.hook-character-card:hover {
  border-color: var(--color-text-secondary);
}

.hook-character-card--selected {
  border-color: var(--color-text-primary);
  background: var(--color-bg-user-bubble);
}

.hook-character-thumb {
  width: 58px;
  height: 72px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-secondary);
  font-size: 18px;
  font-weight: 700;
}

.hook-character-thumb img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.hook-character-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.hook-character-copy strong {
  display: block;
  overflow: hidden;
  color: var(--color-text-primary);
  font-size: 13px;
  font-weight: 650;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hook-character-copy small {
  display: -webkit-box;
  overflow: hidden;
  color: var(--color-text-secondary);
  font-size: 11px;
  line-height: 1.35;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.hook-character-check {
  position: absolute;
  top: 7px;
  right: 7px;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: var(--color-text-primary);
  color: var(--color-bg-root);
}

.hook-upload-zone {
  width: 100%;
  min-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px dashed var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.hook-upload-zone:hover {
  border-color: var(--color-text-secondary);
  background: var(--color-bg-user-bubble);
}

.hook-upload-icon {
  width: 48px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-canvas-surface);
  color: #5fbf92;
}

.hook-upload-title {
  font-size: 14px;
  font-weight: 650;
}

.hook-upload-hint {
  font-size: 12px;
  color: var(--color-text-secondary);
}

.hook-video-preview {
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  overflow: hidden;
  background: var(--color-bg-input);
}

.hook-video-preview video {
  width: 100%;
  max-height: 420px;
  display: block;
  background: #000;
}

.hook-video-meta {
  min-height: 42px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  padding: 10px 12px;
  border-top: 1px solid var(--color-border-input);
  color: var(--color-text-secondary);
  font-size: 12px;
}

.hook-video-meta span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hook-video-meta button {
  width: 26px;
  height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-secondary);
  cursor: pointer;
}

.hook-control-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin: 18px 0;
  padding: 14px 0;
  border-top: 1px solid var(--color-border-input);
  border-bottom: 1px solid var(--color-border-input);
}

.hook-control-row label {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-secondary);
}

.hook-control-row input {
  width: 72px;
  height: 36px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  font: inherit;
  font-size: 13px;
  text-align: center;
  outline: 0;
}

.hook-control-row input:focus {
  border-color: var(--color-text-secondary);
}

.hook-btn-submit,
.hook-btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  font-weight: 650;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.15s ease, background 0.15s ease;
}

.hook-btn-submit {
  width: 100%;
  min-height: 48px;
  padding: 0 20px;
  background: var(--color-text-primary);
  color: var(--color-bg-root);
}

.hook-btn-secondary {
  min-height: 34px;
  padding: 0 12px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-secondary);
}

.hook-btn-submit:hover:not(:disabled),
.hook-btn-secondary:hover {
  opacity: 0.88;
  transform: translateY(-1px);
}

.hook-btn-submit:disabled {
  opacity: 0.36;
  cursor: not-allowed;
  transform: none;
}

.hook-spinner,
.hook-project-spinner {
  display: inline-block;
  border-radius: 50%;
  animation: hook-spin 0.65s linear infinite;
  flex-shrink: 0;
}

.hook-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(0, 0, 0, 0.22);
  border-top-color: currentColor;
}

.hook-project-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid var(--color-border-input);
  border-top-color: var(--color-text-primary);
}

@keyframes hook-spin {
  to { transform: rotate(360deg); }
}

.hook-error {
  display: block;
  margin-top: 10px;
  color: #ef4444;
  font-size: 12px;
  text-align: center;
}

.hook-aside-icon {
  width: 48px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-input);
  color: #5fbf92;
}

.hook-aside-steps {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
}

.hook-aside-steps span {
  padding: 10px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 600;
}

.hook-results {
  width: 100%;
}

.hook-results-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 18px;
  margin-bottom: 16px;
}

.hook-results-header h2 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 31px;
  font-weight: 400;
  line-height: 1.15;
}

.hook-results-header h2 span {
  min-width: 26px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-border-input);
  border-radius: 999px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-secondary);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 11px;
  font-weight: 700;
}

.hook-results-header p {
  margin: 7px 0 0;
  color: var(--color-text-secondary);
  font-size: 13px;
}

.hook-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.hook-card {
  padding: 16px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-canvas-surface);
  transition: border-color 0.15s ease, opacity 0.15s ease;
}

.hook-card--selected {
  border-color: var(--color-text-primary);
}

.hook-card--generating {
  opacity: 0.86;
}

.hook-card-header {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: start;
  gap: 12px;
  margin-bottom: 12px;
}

.hook-select {
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 2px solid var(--color-border-input);
  border-radius: 4px;
  background: transparent;
  color: var(--color-bg-root);
  cursor: pointer;
  padding: 0;
}

.hook-select--active {
  background: var(--color-text-primary);
  border-color: var(--color-text-primary);
}

.hook-card-title-wrap {
  min-width: 0;
}

.hook-card-title-wrap h3 {
  margin: 0;
  color: var(--color-text-primary);
  font-size: 15px;
  font-weight: 650;
  line-height: 1.35;
}

.hook-card-title-wrap p {
  margin: 5px 0 0;
  color: var(--color-text-secondary);
  font-size: 12px;
  line-height: 1.45;
}

.hook-project-status {
  min-width: 74px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}

.hook-project-status button {
  height: 28px;
  padding: 0 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-text-primary);
  color: var(--color-bg-root);
  font: inherit;
  font-size: 11px;
  font-weight: 650;
  cursor: pointer;
  white-space: nowrap;
}

.hook-project-status span {
  color: #ef4444;
  font-size: 11px;
  font-weight: 650;
}

.hook-script-input {
  width: 100%;
  min-height: 132px;
  display: block;
  box-sizing: border-box;
  padding: 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  line-height: 1.55;
  resize: vertical;
  outline: 0;
}

.hook-script-input:focus {
  border-color: var(--color-text-secondary);
}

.hook-script-preview {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}

.hook-expand-btn {
  margin-top: 9px;
  padding: 0;
  border: 0;
  background: none;
  color: #5fbf92;
  font: inherit;
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}

.hook-submit-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 18px;
}

.hook-generating-label {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 13px;
  font-weight: 600;
}

@media (max-width: 920px) {
  .hook-config-grid {
    grid-template-columns: 1fr;
  }

  .hook-panel--aside {
    justify-content: flex-start;
  }
}

@media (max-width: 680px) {
  .hook-localization-grid {
    grid-template-columns: 1fr;
  }

  .hook-main {
    padding: 38px 16px 56px;
  }

  .hook-title {
    font-size: 42px;
  }

  .hook-results-header {
    flex-direction: column;
  }

  .hook-card-header {
    grid-template-columns: auto minmax(0, 1fr);
  }

  .hook-project-status {
    grid-column: 2;
    justify-content: flex-start;
  }

  .hook-control-row {
    align-items: flex-start;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/HookChangerPage.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gCAAgC;EAChC,gCAAgC;EAChC,8EAA8E;EAC9E,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,mDAAmD;EACnD,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,aAAa;AACf;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,kEAAkE;EAClE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,4CAA4C;EAC5C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,eAAe;EACf,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,2CAA2C;EAC3C,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,oBAAoB;EACpB,0CAA0C;EAC1C,kCAAkC;EAClC,kEAAkE;EAClE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,uDAAuD;AACzD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,kEAAkE;EAClE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,cAAc;IACd,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap');\n\n.hook-content {\n  min-height: 100vh;\n  width: 100%;\n  background: var(--color-bg-root);\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  overflow-x: hidden;\n}\n\n.hook-main {\n  width: 100%;\n  max-width: 1080px;\n  margin: 0 auto;\n  padding: 64px 24px 72px;\n}\n\n.hook-header {\n  max-width: 680px;\n  margin-bottom: 30px;\n}\n\n.hook-eyebrow {\n  display: block;\n  margin-bottom: 10px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: uppercase;\n  color: var(--color-text-secondary);\n}\n\n.hook-title {\n  margin: 0;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: clamp(42px, 5.6vw, 68px);\n  font-weight: 400;\n  line-height: 1.02;\n  color: var(--color-text-primary);\n}\n\n.hook-title-em {\n  font-style: italic;\n}\n\n.hook-subtitle {\n  max-width: 560px;\n  margin: 16px 0 0;\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--color-text-secondary);\n}\n\n.hook-config-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.35fr) minmax(280px, 0.75fr);\n  gap: 18px;\n  align-items: stretch;\n}\n\n.hook-panel {\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n}\n\n.hook-panel--form {\n  padding: 22px;\n}\n\n.hook-panel--aside {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 14px;\n}\n\n.hook-section-header {\n  display: flex;\n  gap: 14px;\n  align-items: flex-start;\n  margin-bottom: 18px;\n}\n\n.hook-section-header--compact {\n  margin-bottom: 12px;\n}\n\n.hook-section-number {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 28px;\n  line-height: 1;\n  color: var(--color-text-primary);\n  opacity: 0.16;\n}\n\n.hook-section-header h2,\n.hook-panel--aside h2 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 650;\n  color: var(--color-text-primary);\n}\n\n.hook-section-header p,\n.hook-panel--aside p {\n  margin: 5px 0 0;\n  font-size: 13px;\n  line-height: 1.55;\n  color: var(--color-text-secondary);\n}\n\n.hook-file-input {\n  display: none;\n}\n\n.hook-style-target {\n  margin-top: 18px;\n  padding-top: 18px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n.hook-character-target {\n  margin-top: 18px;\n  padding-top: 18px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n.hook-localization-target {\n  margin-top: 18px;\n  padding-top: 18px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n.hook-localization-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.hook-localization-grid label,\n.hook-localization-notes {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.hook-localization-grid input {\n  width: 100%;\n  height: 40px;\n  box-sizing: border-box;\n  padding: 0 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font: inherit;\n  font-size: 13px;\n  outline: 0;\n}\n\n.hook-localization-grid input:focus {\n  border-color: var(--color-text-secondary);\n}\n\n.hook-localization-notes {\n  margin-top: 12px;\n}\n\n.hook-localization-notes small {\n  color: var(--color-text-secondary);\n  font-size: 10px;\n  font-weight: 500;\n}\n\n.hook-localization-model-note {\n  margin: 12px 0 0;\n  padding: 10px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font-size: 11px;\n  line-height: 1.5;\n}\n\n.hook-style-textarea {\n  width: 100%;\n  min-height: 112px;\n  display: block;\n  box-sizing: border-box;\n  padding: 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  line-height: 1.55;\n  resize: vertical;\n  outline: 0;\n}\n\n.hook-style-textarea:focus {\n  border-color: var(--color-text-secondary);\n}\n\n.hook-style-reference-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.hook-style-reference-bar span {\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.hook-style-upload-btn {\n  min-height: 34px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 0 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-secondary);\n  font: inherit;\n  font-size: 12px;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.hook-style-upload-btn:disabled {\n  opacity: 0.42;\n  cursor: not-allowed;\n}\n\n.hook-style-reference-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(82px, 1fr));\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.hook-style-reference-thumb {\n  position: relative;\n  aspect-ratio: 1;\n  overflow: hidden;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n}\n\n.hook-style-reference-thumb img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.hook-style-reference-thumb button {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  width: 24px;\n  height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: rgba(8, 9, 12, 0.78);\n  color: var(--color-text-primary);\n  cursor: pointer;\n}\n\n.hook-character-auth {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n}\n\n.hook-character-auth p {\n  margin: 0;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.hook-character-tabs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.hook-character-tab {\n  min-height: 34px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font: inherit;\n  font-size: 12px;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.hook-character-tab--active {\n  background: var(--color-text-primary);\n  border-color: var(--color-text-primary);\n  color: var(--color-bg-root);\n}\n\n.hook-character-search {\n  width: 100%;\n  height: 38px;\n  box-sizing: border-box;\n  margin-top: 10px;\n  padding: 0 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font: inherit;\n  font-size: 13px;\n  outline: 0;\n}\n\n.hook-character-search:focus {\n  border-color: var(--color-text-secondary);\n}\n\n.hook-character-state {\n  margin-top: 10px;\n  padding: 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  text-align: center;\n}\n\n.hook-character-grid {\n  max-height: 360px;\n  overflow-y: auto;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 10px;\n  margin-top: 12px;\n  padding-right: 2px;\n}\n\n.hook-character-card {\n  position: relative;\n  min-height: 92px;\n  display: grid;\n  grid-template-columns: 58px minmax(0, 1fr);\n  gap: 10px;\n  align-items: center;\n  padding: 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.hook-character-card:hover {\n  border-color: var(--color-text-secondary);\n}\n\n.hook-character-card--selected {\n  border-color: var(--color-text-primary);\n  background: var(--color-bg-user-bubble);\n}\n\n.hook-character-thumb {\n  width: 58px;\n  height: 72px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-secondary);\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.hook-character-thumb img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.hook-character-copy {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.hook-character-copy strong {\n  display: block;\n  overflow: hidden;\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-weight: 650;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.hook-character-copy small {\n  display: -webkit-box;\n  overflow: hidden;\n  color: var(--color-text-secondary);\n  font-size: 11px;\n  line-height: 1.35;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n\n.hook-character-check {\n  position: absolute;\n  top: 7px;\n  right: 7px;\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  background: var(--color-text-primary);\n  color: var(--color-bg-root);\n}\n\n.hook-upload-zone {\n  width: 100%;\n  min-height: 260px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  border: 1px dashed var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.hook-upload-zone:hover {\n  border-color: var(--color-text-secondary);\n  background: var(--color-bg-user-bubble);\n}\n\n.hook-upload-icon {\n  width: 48px;\n  height: 48px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-canvas-surface);\n  color: #5fbf92;\n}\n\n.hook-upload-title {\n  font-size: 14px;\n  font-weight: 650;\n}\n\n.hook-upload-hint {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.hook-video-preview {\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  overflow: hidden;\n  background: var(--color-bg-input);\n}\n\n.hook-video-preview video {\n  width: 100%;\n  max-height: 420px;\n  display: block;\n  background: #000;\n}\n\n.hook-video-meta {\n  min-height: 42px;\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  gap: 10px;\n  align-items: center;\n  padding: 10px 12px;\n  border-top: 1px solid var(--color-border-input);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n}\n\n.hook-video-meta span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.hook-video-meta button {\n  width: 26px;\n  height: 26px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-secondary);\n  cursor: pointer;\n}\n\n.hook-control-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  margin: 18px 0;\n  padding: 14px 0;\n  border-top: 1px solid var(--color-border-input);\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.hook-control-row label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n}\n\n.hook-control-row input {\n  width: 72px;\n  height: 36px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  font: inherit;\n  font-size: 13px;\n  text-align: center;\n  outline: 0;\n}\n\n.hook-control-row input:focus {\n  border-color: var(--color-text-secondary);\n}\n\n.hook-btn-submit,\n.hook-btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  font-weight: 650;\n  cursor: pointer;\n  transition: opacity 0.15s ease, transform 0.15s ease, background 0.15s ease;\n}\n\n.hook-btn-submit {\n  width: 100%;\n  min-height: 48px;\n  padding: 0 20px;\n  background: var(--color-text-primary);\n  color: var(--color-bg-root);\n}\n\n.hook-btn-secondary {\n  min-height: 34px;\n  padding: 0 12px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-secondary);\n}\n\n.hook-btn-submit:hover:not(:disabled),\n.hook-btn-secondary:hover {\n  opacity: 0.88;\n  transform: translateY(-1px);\n}\n\n.hook-btn-submit:disabled {\n  opacity: 0.36;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.hook-spinner,\n.hook-project-spinner {\n  display: inline-block;\n  border-radius: 50%;\n  animation: hook-spin 0.65s linear infinite;\n  flex-shrink: 0;\n}\n\n.hook-spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(0, 0, 0, 0.22);\n  border-top-color: currentColor;\n}\n\n.hook-project-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid var(--color-border-input);\n  border-top-color: var(--color-text-primary);\n}\n\n@keyframes hook-spin {\n  to { transform: rotate(360deg); }\n}\n\n.hook-error {\n  display: block;\n  margin-top: 10px;\n  color: #ef4444;\n  font-size: 12px;\n  text-align: center;\n}\n\n.hook-aside-icon {\n  width: 48px;\n  height: 48px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-input);\n  color: #5fbf92;\n}\n\n.hook-aside-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.hook-aside-steps span {\n  padding: 10px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.hook-results {\n  width: 100%;\n}\n\n.hook-results-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 18px;\n  margin-bottom: 16px;\n}\n\n.hook-results-header h2 {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 31px;\n  font-weight: 400;\n  line-height: 1.15;\n}\n\n.hook-results-header h2 span {\n  min-width: 26px;\n  height: 22px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--color-border-input);\n  border-radius: 999px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-secondary);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.hook-results-header p {\n  margin: 7px 0 0;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n}\n\n.hook-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.hook-card {\n  padding: 16px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-canvas-surface);\n  transition: border-color 0.15s ease, opacity 0.15s ease;\n}\n\n.hook-card--selected {\n  border-color: var(--color-text-primary);\n}\n\n.hook-card--generating {\n  opacity: 0.86;\n}\n\n.hook-card-header {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  align-items: start;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.hook-select {\n  width: 22px;\n  height: 22px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border: 2px solid var(--color-border-input);\n  border-radius: 4px;\n  background: transparent;\n  color: var(--color-bg-root);\n  cursor: pointer;\n  padding: 0;\n}\n\n.hook-select--active {\n  background: var(--color-text-primary);\n  border-color: var(--color-text-primary);\n}\n\n.hook-card-title-wrap {\n  min-width: 0;\n}\n\n.hook-card-title-wrap h3 {\n  margin: 0;\n  color: var(--color-text-primary);\n  font-size: 15px;\n  font-weight: 650;\n  line-height: 1.35;\n}\n\n.hook-card-title-wrap p {\n  margin: 5px 0 0;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.hook-project-status {\n  min-width: 74px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n}\n\n.hook-project-status button {\n  height: 28px;\n  padding: 0 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-text-primary);\n  color: var(--color-bg-root);\n  font: inherit;\n  font-size: 11px;\n  font-weight: 650;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.hook-project-status span {\n  color: #ef4444;\n  font-size: 11px;\n  font-weight: 650;\n}\n\n.hook-script-input {\n  width: 100%;\n  min-height: 132px;\n  display: block;\n  box-sizing: border-box;\n  padding: 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  line-height: 1.55;\n  resize: vertical;\n  outline: 0;\n}\n\n.hook-script-input:focus {\n  border-color: var(--color-text-secondary);\n}\n\n.hook-script-preview {\n  margin: 0;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  line-height: 1.6;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.hook-expand-btn {\n  margin-top: 9px;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: #5fbf92;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.hook-submit-area {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  margin-top: 18px;\n}\n\n.hook-generating-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  margin: 0;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n@media (max-width: 920px) {\n  .hook-config-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .hook-panel--aside {\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 680px) {\n  .hook-localization-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .hook-main {\n    padding: 38px 16px 56px;\n  }\n\n  .hook-title {\n    font-size: 42px;\n  }\n\n  .hook-results-header {\n    flex-direction: column;\n  }\n\n  .hook-card-header {\n    grid-template-columns: auto minmax(0, 1fr);\n  }\n\n  .hook-project-status {\n    grid-column: 2;\n    justify-content: flex-start;\n  }\n\n  .hook-control-row {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
